module.exports = __webpack_public_path__ + "static/media/background.ca697070.png";